/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Insert_Start_TcInputs */

const en_options_editor_insert_start_tc = /** @type {(inputs: Options_Editor_Insert_Start_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert Start TC On Insert`)
};

const fr_options_editor_insert_start_tc = /** @type {(inputs: Options_Editor_Insert_Start_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer le TC de début à l'insertion`)
};

const de_options_editor_insert_start_tc = /** @type {(inputs: Options_Editor_Insert_Start_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfügen Start TC Bei Einfügen`)
};

const it_options_editor_insert_start_tc = /** @type {(inputs: Options_Editor_Insert_Start_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci Avvia TC All'inserimento`)
};

const ru_options_editor_insert_start_tc = /** @type {(inputs: Options_Editor_Insert_Start_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставьте кнопку Start TC при вставке`)
};

const es_options_editor_insert_start_tc = /** @type {(inputs: Options_Editor_Insert_Start_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar inicio TC en inserción`)
};

const zh_cn2_options_editor_insert_start_tc = /** @type {(inputs: Options_Editor_Insert_Start_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入开始 TC 插入`)
};

const ja_options_editor_insert_start_tc = /** @type {(inputs: Options_Editor_Insert_Start_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`挿入開始TC挿入時`)
};

const hi_options_editor_insert_start_tc = /** @type {(inputs: Options_Editor_Insert_Start_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इंसर्ट स्टार्ट टीसी ऑन इंसर्ट`)
};

const pt_pt2_options_editor_insert_start_tc = /** @type {(inputs: Options_Editor_Insert_Start_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir Iniciar TC em Inserir`)
};

/**
* | output |
* | --- |
* | "Insert Start TC On Insert" |
*
* @param {Options_Editor_Insert_Start_TcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_insert_start_tc = /** @type {((inputs?: Options_Editor_Insert_Start_TcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Insert_Start_TcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_insert_start_tc(inputs)
	if (locale === "de") return de_options_editor_insert_start_tc(inputs)
	if (locale === "it") return it_options_editor_insert_start_tc(inputs)
	if (locale === "ru") return ru_options_editor_insert_start_tc(inputs)
	if (locale === "es") return es_options_editor_insert_start_tc(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_insert_start_tc(inputs)
	if (locale === "ja") return ja_options_editor_insert_start_tc(inputs)
	if (locale === "hi") return hi_options_editor_insert_start_tc(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_insert_start_tc(inputs)
	return en_options_editor_insert_start_tc(inputs)
});